var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:_vm.$style.container},[_c('price'),_vm._v(" "),_c('gift'),_vm._v(" "),_c('GroupPay'),_vm._v(" "),_c('Video'),_vm._v(" "),_c('About'),_vm._v(" "),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }